import {isNumber} from "lodash";
import {numberWithCommas} from "modules/utils";

export const getStatsValue = (value: number | undefined, isShowDecimal: boolean) => {
	if (isNumber(value)) {
		const num = isShowDecimal ? Number(value.toFixed(1)) : value;

		return numberWithCommas(num);
	}

	return "--";
};
